<template>
    <v-container fluid class="select-locale">
        <v-card class="select-card">
            <v-card-text>
                <div class="select-card-title">{{ $t('general.country_placeholder') }}</div>
                <v-list>
                    <v-list-item-group
                        v-model="selectedLocale"
                    >
                        <v-list-item
                            v-for="(country, i) in countries"
                            :key="`item-${i}`"
                            :value="country.locale"
                        >
                            <template v-slot:default="{ active }">
                                <v-list-item-content>
                                    <v-list-item-title>{{ country.name }}</v-list-item-title>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-checkbox
                                        :input-value="active"
                                        color="primary"
                                    />
                                </v-list-item-action>
                            </template>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-card-text>
            <v-card-actions class="px-4 pb-4">
                <v-btn
                    block
                    color="primary"
                    :disabled="!selectedLocale"
                    @click="next"
                >
                    {{ $t('general.next') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import Locale from '@/wrappers/Locale';

export default {
    created() {
        this.countries = [{
            name: this.$t('locales.sr'),
            locale: 'sr',
        }, {
            name: this.$t('locales.me'),
            locale: 'me',
        }]
    },

    data: () => ({
        selectedLocale: null,
        countries: []
    }),

    methods: {
        async next() {
            if(!this.selectedLocale) return

            await Locale.setLocale(this.selectedLocale)
            Locale.setLanguage(this.selectedLocale)

            location.href = '/'
        }
    }
}
</script>

<style lang="scss" scoped>
.select-locale {
    background-color: #1f212b;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .select-card {
        width: 280px;
        max-width: 400px;
    }

    .select-card-title {
        padding: 12px;
        font-size: 18px;
        font-weight: 500;
        text-align: center;
    }
}
</style>
